import { Box, Button, Flex } from '@chakra-ui/react'
import React from 'react'

type Props = {
  onClick: () => void
}

export const ConnectMetaMask = ({ onClick }: Props) => {
  return (
    <Box mt="8">
      <Flex align="center" justify="center">
        <Button
          m="0"
          onClick={onClick}
          colorScheme="teal"
          variant="outline"
          minW={{ base: 'full', md: '60' }}
        >
          Connect MetaMask
        </Button>
      </Flex>
    </Box>
  )
}
